import { apiClient } from './apiClient';
import { Counterparty, CreateCounterpartyRequest, UpdateCounterpartyRequest } from '../types/counterparty';

export const counterpartyService = {
  // Получить список контрагентов компании
  getCompanyCounterparties: async (companyId: string): Promise<Counterparty[]> => {
    const response = await apiClient.get(`/companies/${companyId}/counterparties`);
    return response.data;
  },

  // Получить контрагента по ID
  getCounterparty: async (companyId: string, counterpartyId: string): Promise<Counterparty> => {
    const response = await apiClient.get(`/companies/${companyId}/counterparties/${counterpartyId}`);
    return response.data;
  },

  // Создать нового контрагента
  createCounterparty: async (companyId: string, data: CreateCounterpartyRequest): Promise<Counterparty> => {
    const response = await apiClient.post(`/companies/${companyId}/counterparties`, data);
    return response.data;
  },

  // Обновить контрагента
  updateCounterparty: async (companyId: string, counterpartyId: string, data: UpdateCounterpartyRequest): Promise<Counterparty> => {
    const response = await apiClient.put(`/companies/${companyId}/counterparties/${counterpartyId}`, data);
    return response.data;
  },

  // Удалить контрагента
  deleteCounterparty: async (companyId: string, counterpartyId: string): Promise<void> => {
    await apiClient.delete(`/companies/${companyId}/counterparties/${counterpartyId}`);
  },

  // Поиск контрагентов
  searchCounterparties: async (companyId: string, searchTerm: string): Promise<Counterparty[]> => {
    const response = await apiClient.get(`/companies/${companyId}/counterparties/search?q=${encodeURIComponent(searchTerm)}`);
    return response.data;
  },

  // Синхронизировать контрагента с wFirma
  syncCounterpartyToWFirma: async (companyId: string, counterpartyId: string): Promise<{ status: string; message: string }> => {
    const response = await apiClient.post(`/companies/${companyId}/wfirma/counterparties/${counterpartyId}/sync`);
    return response.data;
  },

  // Удалить синхронизацию контрагента с wFirma
  unsyncCounterpartyFromWFirma: async (companyId: string, counterpartyId: string): Promise<{ status: string; message: string }> => {
    const response = await apiClient.delete(`/companies/${companyId}/wfirma/counterparties/${counterpartyId}/sync`);
    return response.data;
  },

  // Сбросить привязку к wFirma у всех контрагентов компании
  unsyncAllCounterpartiesFromWFirma: async (companyId: string): Promise<{ status: string; message: string; count: number }> => {
    const response = await apiClient.post(`/companies/${companyId}/wfirma/counterparties/unsync-all`);
    return response.data;
  },

  // Синхронизировать всех контрагентов в wFirma
  syncAllCounterpartiesToWFirma: async (companyId: string): Promise<{ status: string; message: string }> => {
    const response = await apiClient.post(`/companies/${companyId}/wfirma/counterparties/sync-all`);
    return response.data;
  }
};
